import { render, staticRenderFns } from "./ArtistAddressInformation.vue?vue&type=template&id=4d10df29&scoped=true"
import script from "./ArtistAddressInformation.vue?vue&type=script&lang=js"
export * from "./ArtistAddressInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d10df29",
  null
  
)

export default component.exports